import { render } from "./AdminArea.vue?vue&type=template&id=720004fe"
import script from "./AdminArea.vue?vue&type=script&lang=js"
export * from "./AdminArea.vue?vue&type=script&lang=js"

import exportComponent from "/home/kreativ-mobil.com/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__